// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__ZbXyt","label":"Radio_label__2qchF","checkMark":"Radio_checkMark__1zg6T","disabled":"Radio_disabled__2nJjj"};